export const enumUserAccountType = {
    unknown: 0,
    member: 1,
    aad: 2,
    passTracking: 99,
}

